import { useEffect, useState } from 'react';
import { getServerUrl } from '../utils/getServerUrl';
import { useQuerySession } from './useQuerySession';
export const useQueryTrialHub = ({ isTrialing, isMobile, skip = false, }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [trialHubData, setTrialHubData] = useState({
        builderPublicApiKey: '',
        shouldDisplayTrialHub: false,
    });
    const { data: sessionData } = useQuerySession();
    useEffect(() => {
        let apiSubscribed = true;
        async function getTrialHubData() {
            var _a;
            const serverUrl = getServerUrl();
            const sidebarUrl = `${serverUrl}/api/v2/navigation-data/trial-hub?is-trialing=${isTrialing}&is-mobile=${isMobile}`;
            const userId = ((_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.customUserId) === null || _a === void 0 ? void 0 : _a.toString()) || '';
            try {
                setIsLoading(true);
                const response = await fetch(sidebarUrl, {
                    credentials: 'omit',
                    headers: {
                        'x-customuser-id': userId,
                    },
                });
                if (!response.ok) {
                    throw new Error('Response was not OK');
                }
                if (apiSubscribed) {
                    const json = await response.json();
                    const { data } = json;
                    setTrialHubData(data);
                }
            }
            catch (error) {
            }
            finally {
                if (apiSubscribed) {
                    setIsLoading(false);
                }
            }
        }
        if (!skip && sessionData)
            getTrialHubData();
        return () => {
            apiSubscribed = false;
        };
    }, [sessionData, skip]);
    return { isLoading, data: trialHubData };
};
//# sourceMappingURL=useQueryTrialHub.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
